<template>
    <base-tool
        :tool-name="tool.name"
        :tool-description="tool.description"
        @back="goBack"
    >
        <el-select
            v-model="selectedSequenceId"
            data-testid="sequence-tool-select"
            class="w-100"
            filterable
            clearable
            placeholder="Choose a sequence"
            @change="handleSequenceChange"
        >
            <el-option-group
                key="Active Sequences"
                label="Active Sequences"
                v-if="activeSequences && activeSequences.length > 0"
                data-testid="sequence-tool-option-group-active"
            >
                <el-option
                    v-for="sequence in activeSequences"
                    :key="sequence.id"
                    :label="sequence.name"
                    :value="sequence.id"
                    :data-testid="`sequence-tool-option-active-${sequence.id}`"
                >
                </el-option>
            </el-option-group>
            <el-option-group
                key="Paused Sequences"
                label="Paused Sequences"
                v-if="pausedSequences && pausedSequences.length > 0"
                data-testid="sequence-tool-option-group-paused"
            >
                <el-option
                    v-for="sequence in pausedSequences"
                    :key="sequence.id"
                    :label="sequence.name"
                    :value="sequence.id"
                    :data-testid="`sequence-tool-option-paused-${sequence.id}`"
                >
                </el-option>
            </el-option-group>
        </el-select>
    </base-tool>
</template>

<script>
import { mapState } from 'vuex'
import BaseTool from './base-tool.vue'
import ToolMixin from './tool-mixin'

export default {
    name: 'SequenceTool',

    mixins: [ToolMixin],

    components: {
        BaseTool
    },

    props: {
        tool: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            selectedSequenceId: null
        }
    },

    computed: {
        ...mapState({
            workflows: state => state.workflows
        }),

        sortedSequences() {
            if (this.workflows && this.workflows.length) {
                const sequences = _.clone(this.workflows)
                return sequences.sort((a, b) => {
                    const textA = a.name.toUpperCase()
                    const textB = b.name.toUpperCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                })
            }
            return []
        },

        activeSequences() {
            if (this.sortedSequences.length) {
                return this.sortedSequences.filter(sequence => sequence.active === true)
            }
            return []
        },

        pausedSequences() {
            if (this.sortedSequences.length) {
                return this.sortedSequences.filter(sequence => sequence.active === false)
            }
            return []
        }
    },

    methods: {
        handleSequenceChange(sequenceId) {
            if (!sequenceId) {
                this.$emit('sequence-selected', null, null)
                return
            }

            const selectedSequence = this.workflows.find(w => w.id === sequenceId)
            this.$emit('sequence-selected', sequenceId, selectedSequence)
        }
    }
}
</script>

